import { render } from "./RedirectRadio.vue?vue&type=template&id=e0a91ece"
import script from "./RedirectRadio.vue?vue&type=script&lang=js"
export * from "./RedirectRadio.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__